<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm3"></a></p>
<div class="fmhT"><i>Africa—Sweden</i></div>
<div class="fmshT">May—August 1993</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595586124_oeb_fm3_r1.vue?04c06101